"use client";

import { useReportWebVitals } from "next/web-vitals";

import Env from "@/core/config/env";

import type { WebVitalPayload } from "./types";

type ReportWebVitalsCallback = Parameters<typeof useReportWebVitals>[0];
type WebVitalMetric = Parameters<ReportWebVitalsCallback>[0];

function createWebVitalPayload(metric: WebVitalMetric): WebVitalPayload {
  return {
    id: metric.id,
    name: metric.name,
    value: metric.value,
    delta: metric.delta,
    rating: metric.rating,
    navigationType: metric.navigationType,
    pathname: window.location.pathname,
    timestamp: Date.now(),
  };
}

function postWebVitalMetric(metric: WebVitalMetric): void {
  const endpoint = Env.webVitalsEndpoint;

  if (!endpoint) {
    return;
  }

  const body = JSON.stringify(createWebVitalPayload(metric));
  const blob = new Blob([body], { type: "application/json" });

  if (navigator.sendBeacon?.(endpoint, blob)) {
    return;
  }

  void fetch(endpoint, {
    body,
    headers: {
      "Content-Type": "application/json",
    },
    keepalive: true,
    method: "POST",
  }).catch((error) => {
    if (Env.debugWebVitals) {
      console.warn("Failed to report web vital metric", error);
    }
  });
}

export function WebVitals() {
  useReportWebVitals(postWebVitalMetric);

  return null;
}
